import {
	required,
	emailValid,
	minLengthPhone,
	maxLengthPhone,
} from "validators";

export const validateEmail = [emailValid];

export const validateBusinessOfficePhone = [
	required,
	minLengthPhone(14),
	maxLengthPhone(14),
];

export const validateBusinessTaxFilling = [required];

export const validateWhenTypeOfBusinessIsOther = (value, allValues) => {
	if (allValues.typeOfBusiness !== "Other" || value) {
		return undefined;
	}
	return "Field is required";
};